import MoneyOffCsred from '@mui/icons-material/MoneyOffCsred';
import { Box, Button, Grid, IconButton, Modal, TextField, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import React, { useState } from 'react';
import api from '../../api';
import useAlertModal from "../AlertModal";
import InstallmentsSelect from "../checkout/InstallmentsSelect"; // Substitua pelo caminho correto do seu arquivo de API.
import PaymentMethodSelect from "../checkout/PaymentMethodSelect";

export default function PaymentModal({ id }) {
    const [open, setOpen] = useState(false);
    const [paymentDate, setPaymentDate] = useState(new Date()); // Define a data atual como padrão
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { showAlert } = useAlertModal();
    const [paymentMethod, setPaymentMethod] = useState('Crédito');
    const [installments, setInstallments] = useState(1);
    const isInstallmentsDisabled = paymentMethod !== "Crédito";

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleConfirm = () => {
        setIsSubmitting(true);
        api.put(`orders/pay-order/${id}`, {
            payment_date: paymentDate.toISOString(),
            payment_method: paymentMethod,
            installments: parseInt(installments),
        })
            .then(response => {
                handleClose(); // Fecha a modal após o sucesso
                showAlert({
                    title: "Sucesso!",
                    message: "Pagamento informado com sucesso.",
                    iconType: "success",
                    redirectTo: "/admin/orders",
                });
            })
            .catch(error => {
                handleClose();
                showAlert({
                    title: "Erro!",
                    message: "Não foi possível informar o pagamento. Tente novamente mais tarde.",
                    iconType: "error",
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <Tooltip title="Venda ainda não paga. Clique aqui caso queira informar o pagamento.">
                <IconButton
                    color="secondary"
                    onClick={handleOpen}
                    aria-label="Informar pagamento"
                >
                    <MoneyOffCsred />
                </IconButton>
            </Tooltip>

            {/* Modal */}
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <h2>Informar Pagamento</h2>
                    <Grid item xs={12} sm={3} sx={{ marginTop: 4 }}>
                        <PaymentMethodSelect
                            label="Meio de pagamento"
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} sx={{ marginTop: 4 }}>
                        <InstallmentsSelect
                            label="Parcelas"
                            value={installments}
                            onChange={(e) => setInstallments(e.target.value)}
                            disabled={isInstallmentsDisabled} // Bloqueia se não for "Crédito"
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} sx={{ marginTop: 4 }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                label="Data de pagamento"
                                value={paymentDate}
                                onChange={(newDate) => setPaymentDate(newDate)}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth sx={{ width: '100%' }} />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, marginTop: 2 }}>
                        <Button onClick={handleClose} variant="outlined" color="error">
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting || !paymentDate}
                        >
                            {isSubmitting ? 'Salvando...' : 'Confirmar'}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}
